module.exports = __webpack_public_path__ + "img/logo.d7a96e07.png";